module.exports = __webpack_public_path__ + "img/11.3b745c71.jpg";